import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CostOverviewValue } from 'src/app/interfaces/basket';

@Component({
    selector: 'app-cost-overview-modal',
    templateUrl: './cost-overview-modal.component.html',
    styleUrls: ['./cost-overview-modal.component.scss'],
    standalone: false
})
export class CostOverviewModalComponent {
  @Input() basketQuote: CostOverviewValue;
  @Input() basketArticlesSum: number;

  constructor(public activeModal: NgbActiveModal) {}

  get totalCalculation(): number {
    if (!this.basketQuote) return 0;
    return (
      this.basketArticlesSum -
      this.basketQuote.invoice_discount -
      this.basketQuote.payment_discount +
      this.basketQuote.shipment_costs +
      this.basketQuote.surcharges_amount
    );
  }
}
